import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { fetchData, fetchTAMData } from "./fetchData";
import { RA } from "./RA";
import { TAM } from "./TAM";
import "./Auction.css";
import { Auction, TAM as TAMType } from "../../../models/auction";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { NewDynamicTab } from "../../../components/Page";

const TABS = ["Reverse Auction", "TAM"];

export const formatDateString = (date: Date | undefined): string => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return ""; // Return empty string or a default date format if date is invalid
  }
  return date.toLocaleDateString("en-GB").split("/").reverse().join("-");
};

export function AuctionPage() {
  const [forecastData, setForecastData] = useState<Auction[]>([]);
  const [TAMData, setTAMData] = useState<TAMType[]>([]);
  const [RALoading, setRALoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false); 
  
  const DefaultDates = useSelector((state: any) => state.defaultDatesSetter.defaultDates);
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);

  const defaultDatesState = useMemo(() => {
    const defaultDateParam = {
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 6)),
      endDate: new Date(),
      key: "selection",
    };
    return {
      "Reverse Auction": {
        type: "range",
        defaultRangeDate: defaultDateParam,
      },
      "TAM": {
        type: "range",
        defaultRangeDate: defaultDateParam,
      },
    };
  }, []);

  const currentDateObj = DefaultDates?.[activeTab]?.defaultRangeDate;
  
  const dateRange = currentDateObj 
    ? { startDate: currentDateObj.startDate, endDate: currentDateObj.endDate } 
    : { startDate: defaultDatesState["Reverse Auction"].defaultRangeDate.startDate, endDate: defaultDatesState["Reverse Auction"].defaultRangeDate.endDate };

  useEffect(() => {
    if (!dateRange.startDate || !dateRange.endDate) return;

    setRALoading(true);
    fetchData({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }).then((data) => {
      setForecastData(data);
      setRALoading(false);
    });

    setLoading(true);
    fetchTAMData({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }).then((data) => {
      const aa = data
        .slice()
        .sort(
          (a, b) =>
            new Date(a.date ?? "").getTime() - new Date(b.date ?? "").getTime(),
        );

      setTAMData(aa);
      setLoading(false);
    });
  }, [dateRange.startDate, dateRange.endDate]);

  useEffect(() => {
    const handleCopyCutPaste = (e: any) => {
      e.preventDefault();
    };

    document.addEventListener("copy", handleCopyCutPaste);
    document.addEventListener("cut", handleCopyCutPaste);
    document.addEventListener("paste", handleCopyCutPaste);

    return () => {
      document.removeEventListener("copy", handleCopyCutPaste);
      document.removeEventListener("cut", handleCopyCutPaste);
      document.removeEventListener("paste", handleCopyCutPaste);
    };
  }, []);

  return (
    <NewDynamicTab
      headerHeight="h-[68px]"
      defaultDates={defaultDatesState}
      header="TAM and DEEP"
      tabs={{
        "Reverse Auction": (
          <RA
            forecastData={forecastData}
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            loading={RALoading}
          />
        ),
        "TAM": (
          <TAM
            TAMData={TAMData}
            loading={loading}
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
          />
        ),
      }}
    />
  );
}
